import Modal from 'react-modal';

import { Container } from './styles';

const customStyles = {
  content: {
    width: '98%',
    maxWidth: 700,
    height: '98%',
    maxHeight: 700,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
  },
};

Modal.setAppElement('#root');

interface Props {
  show: boolean;
  urlCobranca: string;
  onClose: () => void;
}
export function ModalPagamentoCartao({ show, urlCobranca, onClose }: Props) {
  return (
    <Modal
      isOpen={show}
      style={customStyles}
      contentLabel="Pagamento por cartão de crédito"
    >
      <Container>
        <div className="card-header text-white bg-danger">
          <p>Pagamento por cartão de crédito</p>
          <button
            type="button"
            className="btn btn-default close"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <div className="card-body">
          <iframe
            title="Pagamento por cartão de crédito"
            src={urlCobranca}
            className="embed-responsive-item"
          />
        </div>
      </Container>
    </Modal>
  );
}
